<template>
  <div>
    <!-- Rakumart用户指南 -->
    <h1 class="sr-only">{{ $fanyi("Rakumart用户指南") }}</h1>
    <Head ref="head" />
    <section>
      <div class="sectionBox">
        <div class="left">
          <div
            v-for="(item, index) in catalogueList"
            :key="index"
            :title="$fanyi(item.name)"
          >
            <div v-if="item.is_show == 1">
              <div
                class="catalogueContainer dip jsb"
                @click="
                  catalogueIndex = index;
                  item.showStatus = !item.showStatus;
                "
              >
                <div class="flexAndCenter">
                  <img :src="item.icon" alt="" class="menuIcon" />
                  <div :title="item.name" class="u-line">
                    {{ $fanyi(item.name) }}
                  </div>
                </div>
                <img
                  alt=""
                  class="rightIcon"
                  :class="{ rotate180: item.showStatus }"
                  src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202407/6683797671ecb.svg"
                />
              </div>
              <div v-show="item.showStatus">
                <div
                  v-for="(childrenItem, childrenIndex) in item.guide_article"
                  :key="childrenIndex"
                >
                  <div
                    v-if="childrenItem.is_show == 1"
                    :class="
                      childrenItem.id == contentInfo.id
                        ? 'childrenCatalogueContainer flexAndCenter checkedCatalogue'
                        : 'childrenCatalogueContainer flexAndCenter'
                    "
                    @click.stop="
                      updateShowComponents(childrenItem);
                      contentIndex = childrenIndex;
                    "
                  >
                    <img
                      v-if="childrenItem.icon != ''"
                      :src="childrenItem.icon"
                      alt=""
                      class="menuIcon"
                    />
                    <div v-else class="menuIcon"></div>
                    <div :title="childrenItem.title" class="u-line">
                      {{ $fanyi(childrenItem.title) }}
                    </div>
                    <template v-if="childrenItem.h1List.length > 0">
                      <img
                        alt=""
                        class="rightIcon"
                        :class="{ rotate180: childrenItem.showH1List }"
                        src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202407/6683797671ecb.svg"
                        v-if="childrenItem.id != contentInfo.id"
                      />
                      <img
                        alt=""
                        v-else
                        class="rightIcon"
                        :class="{ rotate180: childrenItem.showH1List }"
                        src="../../../assets/icon/arrow-white.svg"
                      />
                    </template>
                  </div>
                  <div
                    v-if="
                      childrenItem.h1List.length > 0 && childrenItem.showH1List
                    "
                  >
                    <div
                      v-for="(h1Item, h1Index) in childrenItem.h1List"
                      :key="h1Index"
                      class="childrenCatalogueContainer flexAndCenter secItem "
                      :class="{
                        checkedCatalogue:
                          childrenItem.id == contentInfo.id &&
                          h1contentIndex == h1Index,
                      }"
                      @click.stop="
                        goAuchor(`h1${h1Index}`, childrenItem, h1Index)
                      "
                    >
                      <div :title="childrenItem.title" class="u-line">
                        {{ h1Item }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="rightTop">
            <template v-for="(item, index) in rightTitle">
              <span :class="{ active: index == rightTitle.length - 1 }">
                {{ item }}
              </span>
              <img
                v-if="index != rightTitle.length - 1"
                class="arrowIcon"
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202407/6683797671ecb.svg"
                alt=""
              />
            </template>
          </div>
          <div class="rightContent">
            <div class="title">
              <span>{{ contentInfo.title }}</span>
              <div class="time">
                {{ $fanyi("更新于") }}：{{ contentInfo.created_at }}
              </div>
            </div>
            <div class="ql-bubble">
              <div
                ref="content"
                class="ql-editor ql-snow ql-bubble"
                @click="imgShow($event)"
                v-html="contentInfo.content"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Foot />
  </div>
</template>

<script>
import Foot from "../../../components/foot/Foot.vue";
import Head from "../../../components/head/HomePageTop.vue";

export default {
  components: {
    Foot,
    Head,
  },
  data() {
    return {
      catalogueList: [],
      guideArticleList: [],
      catalogueIndex: 0,
      h1contentIndex: null,
      contentIndex: 0,
      contentInfo: {},
      rightTitle: [],
    };
  },
  created() {
    this.$api.guideArticleList().then((res) => {
      res.data.forEach((item) => {
        item.showStatus = true;
      });
      res.data.forEach((item, index) => {
        item.guide_article.forEach((guideArticleItem, guideArticleIndex) => {
          guideArticleItem.h1List = [];
          let content = this.$fun.deepClone(guideArticleItem.content);
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = content;
          var tags = tempDiv.querySelectorAll("h1");
          if (tags.length > 0) {
            for (var i = 0; i < tags.length; i++) {
              tags[i].id = `h1${i}`;
              if (tags[i].innerText != "") {
                guideArticleItem.h1List.push(tags[i].innerText);
                if (i == tags.length - 1) {
                  guideArticleItem.content = tempDiv.innerHTML;
                }
              }
            }
          }
          if (
            index == res.data.length - 1 &&
            guideArticleIndex == item.guide_article.length - 1
          ) {
            this.catalogueList = res.data;
            if (this.$route.query.id != undefined) {
              foo: for (let i = 0; i < this.catalogueList.length; i++) {
                for (
                  let j = 0;
                  j < this.catalogueList[i].guide_article.length;
                  j++
                ) {
                  if (
                    this.catalogueList[i].guide_article[j].id ==
                    this.$route.query.id
                  ) {
                    this.catalogueIndex = i;
                    this.contentIndex = j;
                    this.contentInfo = this.catalogueList[i].guide_article[j];
                    if (this.$route.query.h1Id != undefined) {
                      let ids = "#" + this.$route.query.h1Id;
                      this.h1contentIndex = this.$route.query.index;
                      setTimeout(() => {
                        document.querySelector(ids).scrollIntoView(true);
                        let auchor = this.$el.querySelector(ids);
                        window.scrollTo({
                          top: auchor.offsetTop - 100, //举例：用户点击 第二个标签后 页面就会滚动到第二个标签的高度
                          behavior: "smooth", //丝滑滚动
                        });
                      }, 1000);
                    }
                    break foo;
                  }
                }
              }
            } else {
              this.contentInfo = this.catalogueList[0].guide_article[0];
            }
            this.getRightTitle();
          }
        });
      });

      res.data.forEach((item) => {
        item.guide_article.forEach((item2) => {
          item2.showH1List = true;
          item2.content = item2.content.replace(/<p><br><\/p>/g, "<p></p>");
        });
      });
    });
  },
  methods: {
    imgShow(event) {
      if (event.target.getAttribute("src") != undefined) {
        this.$fun.imgPreview(event.target.getAttribute("src"));
      }
    },
    //更新展示的组件
    updateShowComponents(childrenItem) {
      if (this.$route.query.id == childrenItem.id) {
        if (childrenItem.h1List.length > 0 && !!String(this.h1contentIndex)) {
          childrenItem.showH1List = !childrenItem.showH1List;
          this.$forceUpdate();
        }
        return;
      }

      this.contentInfo = childrenItem;
      childrenItem.showH1List = true;
      this.getRightTitle();
      this.$router.push(`/Manuale-utente?id=${childrenItem.id}`);
    },
    goAuchor(id, childrenItem, h1Index) {
      if (childrenItem.id != this.contentInfo.id) {
        this.contentInfo = childrenItem;
      }
      this.$router.push(
        `/Manuale-utente?id=${childrenItem.id}&h1Id=${id}&index=${h1Index}`,
      );
      setTimeout(() => {
        let ids = "#" + id;
        this.h1contentIndex = h1Index;
        document.querySelector(ids).scrollIntoView(true);
        let auchor = this.$el.querySelector(ids);
        window.scrollTo({
          top: auchor.offsetTop - 100, //举例：用户点击 第二个标签后 页面就会滚动到第二个标签的高度
          behavior: "smooth", //丝滑滚动
        });
        this.getRightTitle();
      }, 100);
    },
    getRightTitle() {
      this.rightTitle = [];
      this.catalogueList.forEach((item) => {
        if (item.id == this.contentInfo.category_id) {
          this.rightTitle.push(item.name);
          return;
        }
      });

      this.rightTitle.push(this.contentInfo.title);
      // 获取三级标题
      // if (this.contentInfo.h1List.length > 0 && !!String(this.h1contentIndex)) {
      //   this.rightTitle.push(this.contentInfo.h1List[this.h1contentIndex]);
      //   return;
      // }
    },
  },
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
@import "@/css/mixin.scss";
@import "../../../css/guFont/quillbubble.css";
@import "../../../css/guFont/quillcore.css";
@import "../../../css/guFont/quillsnow.css";

section {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  width: 100%;

  .sectionBox {
    width: 1400px;
    display: flex;
  }

  .left {
    flex: 0 0 320px;
    margin-right: 20px;
    box-sizing: border-box;
    height: calc(100vh - 140px);
    overflow-y: scroll;
    position: sticky;
    top: 116px;
    z-index: 0;

    .catalogueContainer {
      width: 100%;
      min-height: 70px;
      border-radius: 6px;
      color: #000000;
      cursor: pointer;
      font-weight: 600;
      line-height: 26px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 18px;
      padding: 14px 20px;

      .rightIcon {
        width: 24px;
        height: 24px;
        transform: rotate(90deg);
      }

      .rotate180 {
        transform: rotate(0deg);
      }
    }

    .menuIcon {
      margin-right: 10px;
      height: 20px;
      width: 20px;
      min-width: 20px;
    }

    .childrenCatalogueContainer {
      height: 66px;
      border-radius: 6px;
      color: #000000;
      cursor: pointer;

      padding: 10px 20px 10px 50px;
      .u-line {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .rightIcon {
        width: 24px;
        height: 24px;
        margin-left: auto;
        transform: rotate(90deg);
        &.rotate180 {
          transform: rotate(0deg);
        }
      }
    }

    .checkedCatalogue {
      color: #fff;
      background: #009246;
      font-weight: 600;
    }
    .childrenCatalogueContainer.secItem {
      padding-left: 80px;
      color: #000000;
    }
    .secItem.checkedCatalogue {
      color: #000000;
      background: #eaf8e8;
    }
  }

  .left::-webkit-scrollbar {
    width: 0;
  }

  .right {
    width: 1060px;

    .rightTop {
      width: 100%;
      height: 54px;
      @extend .dip;
      justify-content: flex-start;
      gap: 10px;
      .arrowIcon {
        width: 16px;
        height: 16px;
        transform: rotate(90deg);
      }
      span {
        color: #7a7a7a;
        font-size: 14px;
      }
      .active {
        color: #009246;
      }
    }
    .rightContent {
      width: 1060px;
      background: #ffffff;
      padding: 20px;
      box-sizing: border-box;
      min-height: calc(100vh - 140px);

      /deep/ img {
        max-width: 100%;
        cursor: pointer;
      }
    }
  }
}

.title {
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  span {
    font-size: 24px;
    color: #010101;
    font-weight: bold;
  }
  .time {
    font-size: 14px;
    line-height: 20px;
    color: #7a7a7a;
  }
}

.word-break,
p {
  word-break: break-all;
}

.flexAndCenter {
  display: flex;
  align-items: center;
}

.flexAndCenterAndCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ql-editor,
/deep/.ql-editor {
  padding: 0;
  p {
    margin: 15px 0;
    min-height: 1px;
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
